import { TableRow } from "../../../components/DataTable/DataTable";
import { cellValue } from "../../../components/DataTable/cellValue";
import { TruckLoadDTO } from "../../../DTOs/Production/TruckLoadDTO";

export const truckLoadFromTableRow = (
  row: TableRow<number>,
  rowVersion: string | undefined,
  diggingPatternId: number,
  hour: number,
): TruckLoadDTO => new TruckLoadDTO({
  loadingId: row.id,
  diggingPatternId,
  destinationId: cellValue(row, "Destination", "integer") ?? 0,
  truckId: cellValue(row, "Truck", "integer") ?? 0,
  loads: cellValue(row, "Loads", "integer") ?? 0,
  hour,
  materialTypeClassId: cellValue(row, "Material Type Class", "integer") ?? null,
  rowVersion,
});
